import { Button, DropdownButton } from "@habitech/call-to-action";
import { SearchWrapper } from "src/components/MigrateFeed/styles";
import { GridItem } from "src/components/common/grids";
import Loading from "src/components/common/Loading/Loading";

const MigrateStatusSelect = ({ value, setValue, text, handler, loadingMigration, buttonSelect = true }) => {

    const migrationStates = [
        {
            label: "Estado Actual",
            value: "same"
        },
        {
            label: "Activa",
            value: "1"
        },
        {
            label: "Inactiva",
            value: "0"
        },
    ]

    return (
        <SearchWrapper>
            <GridItem sm={4} md={6} lg={8}>
                <DropdownButton
                    dataId="migrationStates"
                    label="Seleccione Nuevo Estado de las propiedades a migrar"
                    originType="pcom"
                    variant="white"
                    placeholder="Seleccione el nuevo estado de las propiedades a migrar"
                    size="fluid medium"
                    listOptions={migrationStates}
                    value={value}
                    setValue={setValue}
                    error={Boolean(false)}
                    errorMessage={''}
                />
            </GridItem>
            {
                value && (

                    <GridItem sm={1} md={1} lg={1}>
                        {
                            loadingMigration ? (
                                <Loading height="80%" />
                            ) : (
                                buttonSelect &&
                                <Button dataId="button-search" originType="pcom" size='medium' fluid onClick={handler}>
                                    {text}
                                </Button>
                            )
                        }

                    </GridItem>
                )
            }
        </SearchWrapper>
    )
}

export default MigrateStatusSelect;